<template>
  <div>
    <tooltip :content="helpMessage" trigger="click" placement="bottom" v-if="!showcustomerSupportURL">
      <button class="btn btn-sm btn-help">Contact Us</button>
    </tooltip>
    <a :href = customerSupportURL target="_blank" class="btn btn-sm btn-help padding" v-if="showcustomerSupportURL">
      Contact Us
    </a>
  </div>
</template>

<script>
import tooltip from "build-ui-x/src/Tooltip";
import { mapState } from "vuex";

export default {
  components: {
    tooltip
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      helpMessage: "",
      showcustomerSupportURL: true,
      customerSupportURL: "https://www.cfmaeroengines.com/contact/"
    };
  },
  computed: {
    ...mapState("user", ["user"])
  },
  created: function() {
    let isSnecmaSafranUser =
      this.user.email.toLowerCase().endsWith("@safrangroup.com") ||
      this.user.email.toLowerCase().endsWith("@snecma.com");
    if (isSnecmaSafranUser || this.user.mdmOrgZone == "SA") {
      this.helpMessage = `<div>Call or e-mail our CFM Support Team! </div><br />
          <div><strong>France: </strong>+33 1 64 14 88 66</div>
          <div><strong>E-mail: </strong>
          <a class="mail" href="mailto:cfm.csc@safrangroup.com">cfm.csc@safrangroup.com</a></div>`;
      this.showcustomerSupportURL = false
    } else {
      this.helpMessage = `<p>Call or e-mail our CFM Support Team! </p>
          <div><strong>US: </strong>1-877-432-3272 </div>
          <div><strong>International: </strong>1- 513 552 3272 </div>
          <div><strong>China and Asia: </strong>+86 400 820 6208 </div>
          <div><strong>E-mail: </strong>
          <a class="mail" href="mailto:aviation.fleetsupport@ge.com">aviation.fleetsupport@ge.com</a></div>`;
      this.showcustomerSupportURL = true
    }
  }
};
</script>
<style lang="less" scoped>
.padding {
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>
